import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    GetProductCollectionApiV2Parameter,
    GetRelatedProductCollectionApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import {
    chain,
    LoadRealTimeInventory,
} from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

interface Parameter {
    id: string;
}

interface Props {
    productInfos?: ProductInfo[];
}

type HandlerType = Handler<Parameter, Props>;

export const LoadRealTimeInventoryCustom: HandlerType = props => {
    if (!props.productInfos || props.productInfos.length === 0 || true) {
        return;
    }

    // const { isAuthenticated } = props.getState().context.session;

    // if (isAuthenticated) {
    //     props.dispatch(
    //         loadRealTimeInventory({
    //             productIds: props.productInfos.map(o => o.productId),
    //             onSuccess: realTimeInventory => {
    //                 props.dispatch({
    //                     type: "Components/ProductInfoLists/CompleteLoadRealTimeInventory",
    //                     id: props.parameter.id,
    //                     realTimeInventory,
    //                 });
    //             },
    //             onError: () => {
    //                 props.dispatch({
    //                     type: "Components/ProductInfoLists/FailedLoadRealTimeInventory",
    //                     id: props.parameter.id,
    //                 });
    //             },
    //             onComplete(realTimeInventoryProps) {
    //                 if (realTimeInventoryProps.apiResult) {
    //                     this.onSuccess?.(realTimeInventoryProps.apiResult);
    //                 } else if (realTimeInventoryProps.error) {
    //                     this.onError?.(realTimeInventoryProps.error);
    //                 }
    //             },
    //         }),
    //     );
    // }
};

replaceInChain(chain, LoadRealTimeInventory, LoadRealTimeInventoryCustom);
